import React from 'react';
import SourceFieldset from '@/features/quickSetup/SourceFieldset';
import TemplateSelector from '@/features/quickSetup/TemplateSelector';
import WizardFormLayout from '@/features/quickSetup/WizardFormLayout';
import type { QuickSetupFormState } from '@/features/quickSetup/types';
import type { Source } from '@/types';

type Props = {
  form: QuickSetupFormState;
  sources: Source[];
  onChange: (patch: Partial<QuickSetupFormState>) => void;
  onToggleSource: (name: string) => void;
  onSetSourceNames?: (names: string[]) => void;
  sourcesEmptyHint?: string;
};

const CONDITIONS = ['', 'new', 'used', 'refurbished'];

export default function MarketplaceWizard({
  form,
  sources,
  onChange,
  onToggleSource,
  onSetSourceNames,
  sourcesEmptyHint,
}: Props) {
  return (
    <WizardFormLayout
      aside={
        <>
          <TemplateSelector category="marketplace" form={form} onApply={onChange} />
          <SourceFieldset
            sources={sources}
            selected={form.source_names}
            onToggle={onToggleSource}
            onSetSelected={onSetSourceNames}
            emptyHint={sourcesEmptyHint}
          />
        </>
      }
    >
      <div className="wizard-field-grid">
        <label className="wizard-field-span-2">
          Search text
          <input
            value={form.search_text}
            onChange={(e) => onChange({ search_text: e.target.value })}
            placeholder="iPhone, PlayStation, drone…"
          />
        </label>

        <label>
          Price min (EUR)
          <input
            type="number"
            value={form.price_min}
            onChange={(e) => onChange({ price_min: e.target.value })}
          />
        </label>
        <label>
          Price max (EUR)
          <input
            type="number"
            value={form.price_max}
            onChange={(e) => onChange({ price_max: e.target.value })}
          />
        </label>

        <label className="wizard-field-span-2">
          Condition
          <select
            value={form.condition}
            onChange={(e) => onChange({ condition: e.target.value })}
          >
            {CONDITIONS.map((c) => (
              <option key={c || 'any'} value={c}>
                {c ? c.charAt(0).toUpperCase() + c.slice(1) : 'Any'}
              </option>
            ))}
          </select>
        </label>
      </div>
    </WizardFormLayout>
  );
}
